import {http} from '@/http'

export default {
  getPeriods(companyId) {
    return http.get('/gratifications', {params: {companyId}})
  },
  getPeriodDetail(periodId) {
    return http.get(`/gratifications/${periodId}`)
  },
  calculate(data) {
    return http.post('/gratifications/calculate', data)
  },
  confirm(periodId) {
    return http.put(`/gratifications/${periodId}/confirm`)
  },
  excludeEmployee(detailId, exclude) {
    return http.put(`/gratifications/details/${detailId}/exclude`, null, {params: {exclude}})
  },
  adjustAmount(detailId, data) {
    return http.put(`/gratifications/details/${detailId}/adjust`, data)
  },
  downloadXlsx(periodId) {
    return http.post(`/gratifications/${periodId}/xlsx`, null, {responseType: 'blob'})
  },
}
